// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__fezdR","consentsList":"PatientConsents_consentsList__1fLFR","consentsListEmpty":"PatientConsents_consentsListEmpty__1I_Do"};